import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { AbstractField } from './abstract-field.component';
import getSymbolFromCurrency from 'currency-symbol-map';

const customValueProvider = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => CurrencyFieldComponent),
  multi: true
};

@Component({
  selector: 'currency-field',
  inputs: [...AbstractField.inputs, 'min', 'max'],
  outputs: [...AbstractField.outputs],
  template: `
    <div
      [floatingLabel]="true"
      [focus]="focused"
      [ngClass]="{
        'validation-failed': validationStatus,
        'custom-amount': isCustomAmount
      }"
    >
      <label for="FIELD={{ id }}">{{ label + (required ? '*' : '') }}</label>
      <input
        [autocomplete]="autocomplete"
        [attr.name]="autocomplete"
        [ngAutonumeric]="config"
        id="FIELD-{{ id }}"
        [(ngModel)]="model"
        [placeholder]="label + (required ? ' *' : '')"
        class="form-control input-currency"
        [disabled]="disabled"
        [required]="required"
        (change)="localOnChange()"
        type="text"
      />
    </div>
  `,
  providers: [customValueProvider]
})
export class CurrencyFieldComponent extends AbstractField implements OnInit {
  type;
  model = 0;
  validationStatus = false;
  @Input() currencyCode;
  @Input() isCustomAmount;
  config: any = {};
  constructor() {
    super();
  }

  ngOnInit() {
    this.config = {
      currencySymbol: getSymbolFromCurrency(this.currencyCode || 'USD'),
      digitGroupSeparator: ',',
      currencySymbolPlacement: 'p',
      emptyInputBehavior: 'zero',
      minimumValue: 0
    };
  }

  localOnChange() {
    this.onChange(this.model);
  }
}
